import React from "react";
import { _LandingMenuRoot } from "./LandingMenu.styled";
import Typography from "../../../Foundation/Typography/Typography";
import Button from "../../../Foundation/Button/Button";

export type LandingMenuStyleTemplate = "standard" | "compact";

interface ILandingMenuProps {
  title?: string;
  subtitle?: string;
  linkText?: string;
  styleTemplate?: LandingMenuStyleTemplate;
  onClick?: () => void;
}

const LandingMenu = (props: ILandingMenuProps) => {
  const {
    title,
    subtitle,
    linkText,
    styleTemplate = "standard",
    onClick,
  } = props;
  const isCompact = styleTemplate === "compact";

  return (
    <_LandingMenuRoot
      className={`landing-menu landing-menu__menu js-active${
        isCompact ? " landing-menu--compact" : ""
      }`}
    >
      <div className="landing-menu__container js-active">
        {isCompact ? (
          <Typography
            align="center"
            variant="subtitle2"
            as="button"
            type="button"
            className="landing-menu__menu__compact-link"
            onClick={onClick}
          >
            {subtitle}
          </Typography>
        ) : (
          <>
            <Typography
              align="center"
              variant="h4"
              className="landing-menu__menu__title"
            >
              {title}
            </Typography>

            <Typography
              align="center"
              variant="subtitle1"
              className="landing-menu__menu__text"
            >
              {subtitle}
            </Typography>

            <div>
              <Button
                className="btn-classic btn-add js-btn landing-box__button landing-box__button--black"
                $hover={false}
                $color={""}
                onClick={onClick}
              >
                <span className="btn-classic__base">{linkText}</span>
              </Button>
            </div>
          </>
        )}
      </div>
    </_LandingMenuRoot>
  );
};

export default LandingMenu;
